import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { UploadTenantLogoAction } from '../../domains/uploadTenantLogo/actions.types';

import { UploadTenantLogoLifecycle } from './types';

const initialState: UploadTenantLogoLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<UploadTenantLogoLifecycle, UploadTenantLogoAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'UPLOAD_TENANT_LOGO.FULFILLED':
      return setFulfilled(action.payload);
    case 'UPLOAD_TENANT_LOGO.PENDING':
      return setPending();
    case 'UPLOAD_TENANT_LOGO.REJECTED':
      return setRejected(action.payload.error);
    case 'UPLOAD_TENANT_LOGO.RESET':
      return initialState;
    default:
      return state;
  }
};

export default reducer;
